export default {
  LOAD_PLANNING_STREAM (state, payload) {
    state.planningStream = payload
  }
}



// WEBPACK FOOTER //
// ./widgetSrc/app/widget/vuex/mutations.js